export default __webpack_public_path__ + "static/avocat-services-personnel-entreprise-litige-laval-6595d236808699a65c52609ea3f4c477.jpg";